<template>
    <div style="margin: 10px; background-color: white; position:relative;">
        <div class="container-fluid">
            <div class="row">
                <div class="col-xs-4 col-sm-4">&nbsp;</div> <div class="col-xs-4 col-sm-4">&nbsp;</div> <div class="col-xs-4 col-sm-4">&nbsp;</div>
            </div>
            <div class="row">
                <div v-if="!this.$root.ecIntegrationActive">
                    <div class="col-xs-4 col-sm-4 text-center"> 
                        <span id="step1LblId"  class="label label-pill label-primary stepNumber">1</span>
                    </div>
                    <div class="col-xs-4 col-sm-4 text-center"> 
                        <span v-if="!this.$Behaviors.hideDeliveryCartStep" id="step2LblId" class="label label-pill label-default stepNumber">2</span>
                    </div>
                    <div v-if="!this.$Behaviors.hideDeliveryCartStep" class="col-xs-4 col-sm-4 text-center"> 
                        <span id="step3LblId" class="label label-pill label-default stepNumber">3</span>
                    </div>
                    <div v-else class="col-xs-4 col-sm-4 text-center"> 
                        <span id="step3LblId" class="label label-pill label-default stepNumber">2</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-4 col-sm-4">&nbsp;</div> <div class="col-xs-4 col-sm-4">&nbsp;</div> <div class="col-xs-4 col-sm-4">&nbsp;</div>
            </div>
            <div class="row">
                <div v-if="!this.$root.ecIntegrationActive">
                    <div class="col-xs-4 col-sm-4">
                        <p class="text-center" ><strong>{{verificaProdottiLbl}}</strong></p>
                    </div>
                    <div class="col-xs-4 col-sm-4">
                        <p v-if="!this.$Behaviors.hideDeliveryCartStep" class="text-center" ><strong>{{opzioniConsegnaLbl}}</strong></p>
                    </div>
                    <div class="col-xs-4 col-sm-4">
                        <p class="text-center" ><strong>{{confermaLbl}}</strong></p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-4 col-sm-4">&nbsp;</div> <div class="col-xs-4 col-sm-4">&nbsp;</div> <div class="col-xs-4 col-sm-4">&nbsp;</div>
            </div>
        </div>
        <span>
            <component :is="active" 
                v-on:changeComponentEvent="onChangeComponentModal" 

                v-on:onOpenAddProductEvent="onOpenAddProductModal"
                v-on:onOpenAddAddressEvent="onOpenAddAddressModal"
                v-on:onOpenModifyAddressEvent="onOpenModifyAddressModal"
                v-on:onOpenOtherRequesterEvent="onOpenOtherRequesterModal"
                v-on:onOpenOtherAddressEvent="onOpenOtherAddressModal"

                v-on:onCleanShopCartEvent="onCleanShopCartModal"
                v-on:onDeleteAddressEvent="onDeleteAddressModal"
                v-on:onSaveDraftEvent="saveDraft" 
                v-on:onSaveOrderEvent="saveOrder"

                v-on:onUploadFileEvent="onOpenUploadFileModal"

                v-on:emptyShopCart="onEmptyShopCart"

                ref="shopCartComponent" :isAlternate="isShopCart2Alternate"></component>
                
            <single-modal @API="AddProductModal = $event" :title="$Jed.firstUpperTranslate('add')+' '+$Jed.translate('product')" :options="openAddProductModalConfigs" >
                <div class="modal-body" style="height: auto; overflow: auto;">
                    <component :is="addProductComponent" v-bind:parentList="dataListForChildObj" v-on:onCancelAddProductEvent="onCancelAddProductModal"
                                v-on:onAddProductEvent="onAddProductModal" ></component>
                </div>
            </single-modal>

            <single-modal @API="AddQuantityModal = $event" :title="$Jed.firstUpperTranslate('edit')+' '+$Jed.translate('qty')" :options="openAddQuantityModalConfigs"  >
                <div class="modal-body" style="height: auto; width:300px; overflow: auto;">
                    <component :is="addQuantityComponent" v-bind:rowData="dataForChildObj" v-bind:minQuantity="minQuantity" v-bind:maxQuantity="maxQuantity"   v-on:onCancelAddQuantityEvent="onCancelAddQuantityModal"
                                v-on:onAddQuantityEvent="onAddQuantityModal" ></component>
                </div>
            </single-modal>

            <single-modal @API="OtherAddressModal = $event" :title="$Jed.firstUpperTranslate('select')+' '+$Jed.firstUpperTranslate('address',1)" :options="openOtherAddressModalConfigs" >
                <div class="modal-body" style="height: auto; overflow: auto;">
                    <component :is="otherAddressComponent" v-on:onCancelOtherAddressEvent="onCancelOtherAddressModal" v-on:onConfirmOtherAddressEvent="onConfirmOtherAddressModal" 
                        v-on:onOpenAddAddressEvent="onOpenAddAddressModal" v-on:onOpenModifyAddressEvent="onOpenModifyAddressModal" v-on:onDeleteAddressEvent="onDeleteAddressModal" :addressList="addressList">
                    </component>
                </div>
            </single-modal>

            <single-modal @API="OtherRequesterModal = $event" :title="$Jed.firstUpperTranslate('select')+' '+$Jed.firstUpperTranslate('requester')" :options="openOtherRequesterModalConfigs" >
                <div class="modal-body" style="height: auto; overflow: auto;">
                    <component :is="addRequesterComponent" v-on:onCancelOtherRequesterEvent="onCancelOtherRequesterModal" v-on:onConfirmOtherRequesterEvent="onConfirmOtherRequesterModal" 
                        v-on:onOpenAddUserEvent="onOpenAddUserModal" v-on:onOpenModifyUserEvent="onOpenModifyUserModal" v-on:onDeleteUserEvent="onDeleteUserModal" :usersList="usersList">
                    </component>
                </div>
            </single-modal>

            <single-modal @API="AddUserModal = $event" :title="$Jed.firstUpperTranslate('add user')" :options="openAddUserModalConfigs">
                <div class="modal-body" style="height: auto; overflow: auto;">
                    <component :is="addUserComponent" v-on:onConfirmAddUserEvent="onConfirmAddUserModal" v-on:onCancelAddUserEvent="onCancelAddUserModal"></component>
                </div>
            </single-modal>  

            <single-modal @API="ModifyUserModal = $event" :title="$Jed.firstUpperTranslate('edit')+' '+$Jed.firstUpperTranslate('user')" :options="openModifyUserModalConfigs">
                <div class="modal-body" style="height: auto; overflow: auto;">
                    <component :is="modifyUserComponent" v-on:onConfirmModifyUserEvent="onConfirmModifyUserModal" 
                        v-on:onCancelModifyUserEvent="onCancelModifyUserModal" ref="modUserModalComp"></component>
                </div>
            </single-modal>  

            <single-modal @API="AddAddressModal = $event" :title="$Jed.firstUpperTranslate('add')+' '+$Jed.translate('address', 1)" :options="openAddAddressModalConfigs" >
                <div class="modal-body">
                    <component :is="addAddresComponent"  v-bind:addressObj="addressTmpObj"  v-on:onCancelAddAddressEvent="onCancelAddAddressModal"
                v-on:onConfirmAddAddressEvent="onConfirmAddAddressModal" ref="addressModalComp"  ></component>
                </div>
            </single-modal>

            <single-modal @API="ModifyAddressModal = $event" :title="$Jed.firstUpperTranslate('edit')+' '+$Jed.translate('address')" :options="openAddAddressModalConfigs" >
                <div class="modal-body">
                    <component :is="modAddressComponent"  v-bind:addressObj="addressTmpObj"  v-on:onCancelModAddressEvent="onCancelModifyAddressModal"
                        v-on:onConfirmModifyAddressEvent="onConfirmModifyAddressModal" ref="modAddressModalComp"></component>
                </div>
            </single-modal>

            <single-modal @API="UploadFileModal = $event" :title="$Jed.firstUpperTranslate('upload file')" :options="openUploadFileModalConfigs" :closeModal="closeUploadModal">
                <div class="modal-body">
                    <component :is="uploadFileComponent" ref="uploadFileComp" :oid="orderId"></component>
                </div>
            </single-modal>

        </span>
    </div>

</template>

<script>

import ShopCart from './ShopCart.vue';
import ShopCart2 from './ShopCart2.vue';
import ShopCart2Alt from './ShopCart2Alternate.vue';
import ShopCart3 from './ShopCart3.vue';
import AddProduct from './AddProduct.vue';
import AddQuantity from './AddQuantity.vue';
import AddAddress from './AddAddress.vue';
import ModifyAddress from './ModifyAddress.vue';
import OtherAddress from './OtherAddress.vue';
import OtherRequester from './OtherRequester.vue';
import AddUser from './AddUser.vue';
import ModifyUser from './ModifyUser.vue';
import Confirm from "../../dynamic/modalWrapper/Confirm.vue"
import SingleModal from "../../dynamic/modalWrapper/SingleModal.vue";
import OrderRowData from "./OrderRowData.js"
import UploadFile from "../../others/UploadFile.vue"
import { eventBus } from "../../../eventbus";

const USE_REGISTRY = true;

export default {
    components : {
        ShopCart,
        ShopCart2,
        ShopCart2Alt,
        ShopCart3,
        Confirm,
        AddProduct,
        AddQuantity,
        SingleModal,
        AddAddress,
        ModifyAddress,
        OtherAddress,
        OtherRequester,
        AddUser,
        ModifyUser,
        UploadFile 
    },
    data: function(){
        return {
            active: "ShopCart",
            addProductComponent: "AddProduct",
            addAddresComponent: "AddAddress",
            modAddressComponent: "ModifyAddress",
            otherAddressComponent: "OtherAddress",
            addQuantityComponent: "AddQuantity",
            addRequesterComponent: "OtherRequester",
            addUserComponent: "AddUser",
            modifyUserComponent: "ModifyUser",
            uploadFileComponent: "UploadFile",
            verificaProdottiLbl: this.$Jed.firstUpperTranslate('product',2),
            opzioniConsegnaLbl: this.$Jed.firstUpperTranslate('delivery'), 
            confermaLbl: this.$Jed.firstUpperTranslate('recap'), 
            dataForChildObj: null,
            dataListForChildObj: null,
            minQuantity: null,
            maxQuantity: null,
            openAddProductModalConfigs:{
                showCancelButton: false,
                showConfirmButton: false,
                closeAfterConfirm: true,              
                onConfirm: function(){}
            },
            openAddQuantityModalConfigs:{
                showCancelButton: false,
                showConfirmButton: false,
                closeAfterConfirm: true,   
                width: "300",                 
                onConfirm: function(){}
            },
            openAddAddressModalConfigs:{
                showCancelButton: false,
                showConfirmButton: false,
                closeAfterConfirm: true,
                onConfirm: function(){}
            },
            openOtherRequesterModalConfigs:{
                showCancelButton: false,
                showConfirmButton: false,
                closeAfterConfirm: true,              
                onConfirm: function(){}
            },
            openOtherAddressModalConfigs:{
                showCancelButton: false,
                showConfirmButton: false,
                closeAfterConfirm: true,              
                onConfirm: function(){}
            },
            openAddUserModalConfigs:{
                showCancelButton: false,
                showConfirmButton: false,
                closeAfterConfirm: true,              
                onConfirm: function(){}
            },
            openModifyUserModalConfigs:{
                showCancelButton: false,
                showConfirmButton: false,
                closeAfterConfirm: true,              
                onConfirm: function(){}
            },
            openUploadFileModalConfigs:{
                showCancelButton: false,
                showConfirmButton: false,
                closeAfterConfirm: true,              
                onConfirm: function(){}
            },
            isShopCart2Alternate: this.$Behaviors.shopCart2Alternate,
            addressTmpObj: null,
            usersList: null,
            addressList: null,
            orderId: null
        }
    },
    created: function() {
        var vm = this;
         if(this.$root.shopCartData == null) {
            if(!vm.$Configs.ecp.ecidUrl){
                vm.$root.newCart('start'); //se è stato passato il link e-commerce, non inizializzo il carrello
            }
            var tempId = this.$root.getTempReferenceId();
        }
    },
    mounted: function() {
        var vm = this,
            idFromArch = this.$route.params.id, //caso in cui arrivo dall'archivio e voglio aprire nel carrello un ordine specifico
            idOfCurrentCart = this.$root.shopCartData ? this.$root.shopCartData.id : 0; //caso in cui c'è un carrello in corso e voglio tornare a compilare quel carrello
            //se è già stata fatta la sync, sarà buono l'id
            //se non è stata fatta la sync che valore ha l'id? 
        
        if(idFromArch) {
            this.$root.getCart(idFromArch).then(()=>{
                if( vm.$root.shopCartData && vm.$root.shopCartData.riferimento.length === 0 ) {
                    vm.$root.shopCartData.riferimento = idFromArch; 
                    vm.$root.shopCartData.id = idFromArch;
                }
                this.$refs.shopCartComponent.updateData('archivio');
            })
        }else if(idOfCurrentCart != 0) {
            this.$root.shopCartData.riferimento = idOfCurrentCart; 
            this.$refs.shopCartComponent.updateData();
        }else{
            var tempId = this.$root.getTempReferenceId();
            if(this.$root.shopCartData)this.$root.shopCartData.riferimento = tempId;
            this.$refs.shopCartComponent.updateData();
        }
    },
    methods: {
        onOpenUploadFileModal(oid){
            this.orderId = oid.toString();
            this.UploadFileModal.open();
        },
        closeUploadModal(){
            eventBus.$emit("closeUploadModalEvent")
        },
        onChangeComponentModal(requestedStep, data) {
            console.log("Cambio step: ", requestedStep);
            
            //se non è un nuovo ordine ma sto salvando i dati tra step intermedi
            if(data.id != 0 && data.riferimento > 0){
                //salvo la bozza prima di proseguire perchè potrebbero essere cambiate info nei passaggi intermedi nel carrello 
                this.$root.saveDraft();
            }

            if( requestedStep != this.currentStep) {
                this.currentStep = requestedStep;

                $('#step1LblId').removeClass('label-primary'); 
                $('#step2LblId').removeClass('label-primary'); 
                $('#step3LblId').removeClass('label-primary');            

                switch(this.currentStep) {
                    case 2: {
                            if( this.isShopCart2Alternate)
                                this.active = "ShopCart2Alt";
                            else
                                this.active = "ShopCart2";
                            $('#step1LblId').addClass('label-default'); 
                            $('#step2LblId').addClass('label-primary'); 
                            $('#step3LblId').addClass('label-default'); 
                        }
                        break;
                    case 3: {
                            this.active = "ShopCart3";
                            $('#step1LblId').addClass('label-default'); 
                            $('#step2LblId').addClass('label-default'); 
                            $('#step3LblId').addClass('label-primary'); 
                        }
                        break;
                    case 1:
                    default:{
                            this.active = "ShopCart";                    
                            $('#step1LblId').addClass('label-primary'); 
                            $('#step2LblId').addClass('label-default'); 
                            $('#step3LblId').addClass('label-default'); 
                        }

                        break;
                    }
            }
        },
        onOpenAddProductModal(dataList) {
            console.log("onOpenAddProductModal", dataList);
            this.dataListForChildObj = dataList;
            this.AddProductModal.open();
        },
        onCleanShopCartModal() {
            var vm = this,
                ok = null,
                no = null,
                e = null;
            
            console.log('onCleanShopCartModal - shopCartData.id: ', this.$root.shopCartData.id, ' - shopCartData.riferimento: ', this.$root.shopCartData.riferimento)
            
            if(this.$Configs.ecp.tipoIntegrazione && this.$Configs.ecp.tipoIntegrazione.includes("Invia prodotti nel carrello")){
                ok = function(){
                    var vma = this
                    vm.$root.deleteCart(vm.$root.shopCartData.riferimento);
                    vm.$root.newCart().then(()=>{
                        vm.$refs.shopCartComponent.updateData();
                        vm.changeStep(1);
                        vma.close();
                    })
                }
                no = function(){
                    var vma = this
                    vma.close();
                }
                e = {
                    message: this.$Jed.firstUpperTranslate('Do you want to delete all products in cart?'), 
                    ok: ok,
                    no: no
                }
            }else{
                ok = function(){
                    var vma = this
                    var carrelloUpd = vm.$refs.shopCartComponent.getData();
                
                    if(carrelloUpd){
                        vm.$root.saveCart(function(err) {
                            if (err) {
                                console.log("error : " + err);
                            }else {
                                console.log("onCleanShopCartModal - ordine ", vm.$root.shopCartData.id, " salvato");
                                vm.$root.newCart().then(()=>{
                                    vm.$root.shopCartData.riferimento = vm.$root.getTempReferenceId();
                                    vm.$refs.shopCartComponent.updateData();
                                    vm.changeStep(1);
                                    vma.close();
                                })
                            } 
                        }) 
                    }
                }
                no = function(){
                    var vma = this
                    vm.$root.deleteCart(vm.$root.shopCartData.riferimento);
                    vm.$root.newCart().then(()=>{
                        vm.$refs.shopCartComponent.updateData();
                        vm.changeStep(1);
                        vma.close();
                    })
                }
                e = {
                    message: this.$Jed.firstUpperTranslate('Do you want to save the cart as order draft?'), 
                    ok: ok,
                    no: no
                }
            }
            
            eventBus.$emit("confirm", e)
            
        },
        onOpenAddQuantityModal(data) {
            console.log("onOpenAddQuantity", data);
            this.dataForChildObj = data;
            this.minQuantity = this.dataForChildObj && this.dataForChildObj.qty ? this.dataForChildObj.qty : 1;
            this.maxQuantity = 9999999;
            $("#quantita2Id").val(this.dataForChildObj && this.dataForChildObj.qty ? this.dataForChildObj.qty : 1);
            $("#quantita2Id").attr('min',this.minQuantity);
            $("#quantita2Id").attr('max',this.maxQuantity);

            this.AddQuantityModal.open();
        },
        //________________ADD/MODIFY/DELETE ADDRESS________________________________
        onOpenAddAddressModal() {
            this.addressTmpObj = null;
            this.AddAddressModal.open();
        },
        onOpenModifyAddressModal(data) {
            this.addressTmpObj = data;
            this.$refs.modAddressModalComp.fillFields(data);

            this.ModifyAddressModal.open();
        },
        onDeleteAddressModal(data) {
            this.$root.DeleteAddress(data);
            try{
                this.$refs.shopCartComponent.loadCollectionAddress();
                this.$refs.shopCartComponent.fillAddressesDropdown();
            }catch(e){console.log(e)}
        },
        onCancelAddAddressModal() {
            this.AddAddressModal.close();
        },
        onCancelModifyAddressModal(){
            this.ModifyAddressModal.close();
        },
        onConfirmAddAddressModal(data) {
            this.AddAddressModal.close();
            this.$root.SaveAddress(data);
            this.$refs.shopCartComponent.fillAddressesDropdown(data);
        },
        onConfirmModifyAddressModal(data) {
            this.ModifyAddressModal.close();
            this.$root.SaveAddress(data);
            $('#TabellaIndirizzi').jqxGrid('updatebounddata'); //aggiorno il contenuto della grid di OtherAddress
            this.$refs.shopCartComponent.fillAddressesDropdown(data);
        },
        //________________OTHER ADDRESS________________________________
        onOpenOtherAddressModal(data){
            this.addressList = data;
            console.log(this.addressList)
            this.OtherAddressModal.open();
        },
        onConfirmOtherAddressModal(data) {
            this.$refs.shopCartComponent.updateData(data);
            this.OtherAddressModal.close();
        },
        onCancelOtherAddressModal(){
            this.OtherAddressModal.close();
        },
        //________________ADD PRODUCT________________________________
        onCancelAddProductModal() {
            this.AddProductModal.close();
        },
        onConfirmAddProductModal() {
            this.AddProductModal.close();
        },
        onCancelAddQuantityModal() {
            this.AddQuantityModal.close();
        },
        onAddProductModal(data)  {
            this.onOpenAddQuantityModal(data);
        },
        onAddQuantityModal(data)  {
            this.$root.$emit('clearAllFields');
            this.AddQuantityModal.close();
            this.AddProductModal.close();

            this.$refs.shopCartComponent.getData() //salvo i dati che potrei aver inserito nella prima schermata carrello

            if(this.$root.addProductToCart(data)) {      
                this.$root.saveDraft();
                this.$refs.shopCartComponent.updateData();                
            }
        },
        saveDraft(data) {
            this.$root.saveDraft();
            var vm = this;
            vm.$root.newCart().then(()=>{
                vm.$root.shopCartData.riferimento = vm.$root.getTempReferenceId();
                vm.$refs.shopCartComponent.updateData();
                vm.$root.simpleNotification("info", {
                    title: "", 
                    message: vm.$Jed.firstUpperTranslate("order has been saved as draft", null) 
                });
                vm.changeStep(1);
            })
        },
        saveOrder(data) {
            console.log("onSaveOrderEvent: ", data);

            var vm = this;

            if(!data){
                alert('Carrello vuoto')
                return;
            }

            var firstState = this.$root.getFirstOrderStatus()
            if( data.statoOrdine == firstState.id ) { 
                data.statoOrdine = firstState.to; 
            }
            
            var reg_orders = this.$root.dbRegistry.getCollection('orders'),
                order = reg_orders.find({'id': data.id})[0];
            if(order){
                this.$root.saveCart(function(err) { //aggiorno le informazioni dell'ordine che potrebbero essere cambiate nella terza schermata dell'ordine
                    if (err) {
                        console.log("error : " + err);
                    }else{
                        vm.$root.dbRegistry.saveDatabase(function(err) {
                            if (err) {
                                console.log("saveDatabase - error : " + err);
                            } else {
                                if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                                vm.$root.simpleNotification("info", {
                                    title: "", 
                                    message: vm.$Jed.firstUpperTranslate("order has been sent", null) 
                                });

                                vm.$root.newCart().then(()=>{
                                    vm.$refs.shopCartComponent.updateData();
                                    vm.changeStep(1);
                                })

                                eventBus.$emit("cartFilled",vm.$root.shopCartData.prodotti.length);
                            }
                        });
                    } 
                })
            }else{
                eventBus.$emit("alert", {
                    type: "warning", 
                    message: this.$Jed.firstUpperTranslate('order has not been syncronized and so it has not been sent')
                });
            }
        },
        //________________OTHER REQUESTER________________________________
        onOpenOtherRequesterModal(data){
            this.usersList = data;
            this.OtherRequesterModal.open();
        },
        onConfirmOtherRequesterModal(data) {
            this.$refs.shopCartComponent.updateData(data);
            this.OtherRequesterModal.close();
        },
        onCancelOtherRequesterModal(){
            this.OtherRequesterModal.close();
        },
        //________________ADD/MODIFY/DELETE USER_________________________________
        onOpenAddUserModal(){
            this.AddUserModal.open();
        },
        onConfirmAddUserModal(data) {
            this.AddUserModal.close();
            this.$root.SaveUser(data);
        },
        onCancelAddUserModal(){
            this.AddUserModal.close();
        },
        onOpenModifyUserModal(data){
            this.$refs.modUserModalComp.fillFields(data);
            this.ModifyUserModal.open()
        },
        onDeleteUserModal(obj, i){
            this.$root.DeleteUser(obj, i)
            this.usersList = this.$root.dbRegistry.getCollection('users').data
        },
        onConfirmModifyUserModal(data) {
            this.ModifyUserModal.close();
            this.$root.SaveUser(data); 
            $('#TabellaUtenti').jqxGrid('updatebounddata'); //aggiorno il contenuto della grid di OtherRequester
        },
        onCancelModifyUserModal(){
            this.ModifyUserModal.close();
        },
        onConfirmDeleteUserModal(data) {
            //this.$root.SaveUser(data);
        },
        //________________CHANGE CART STEP________________________________
        changeStep: function(val) {
            try {
                this.$refs.shopCartComponent.changeStep(val);
            }
            catch(err) {
                console.log("Metodo non definito nel componente", err);
            }
        },
        onEmptyShopCart: function (){
            var vm = this;
            vm.$root.deleteCart(vm.$root.shopCartData.riferimento);
            vm.$root.newCart().then(()=>{
                vm.$refs.shopCartComponent.updateData();
                vm.changeStep(1);
            })
        }
    }

}
</script>

<style>
.stepNumber {
    border-radius: 20px;
    font-size: 22px; 
    /*cursor: pointer;*/
}
</style>



// WEBPACK FOOTER //
// src/components/views/shopcart/ShopWrapper.vue?bb345d0c